import React from 'react';
import styled from 'styled-components';
import { DatePickerInput, Dropdown } from '@leapeasy/ui-kit';

import { ApplicationCreatedDateRangeFilterFields } from './ApplicationCreatedDateRangeFilterFields';

export function ApplicationListDropFilterFields({
  stageOptions,
  appTypeOptions,
  selectedStageDraft,
  onStageDraftChange,
  selectedAppTypeDraft,
  onAppTypeDraftChange,
  selectedLeaseDateDraft,
  onLeaseDateDraftChange,
  selectedCreatedDateDraft,
  onCreatedDateDraftChange,
  selectedTenantCountDraft,
  onTenantCountDraftChange,
}) {
  return (
    <DropFilterContainer>
      <Dropdown
        onChange={(e) => onStageDraftChange(e.target.value)}
        options={stageOptions}
        value={selectedStageDraft}
        multiselect
        showSearch={false}
        placeholder="Select item"
        placeholderFlag
        label="Stage of Application"
        style={{ width: '100%' }}
      />
      <Dropdown
        onChange={(e) => onAppTypeDraftChange(e.target.value)}
        options={appTypeOptions}
        value={selectedAppTypeDraft}
        multiselect
        showSearch={false}
        placeholder="Select item"
        placeholderFlag
        label="Application Type"
        style={{ width: '100%' }}
      />
      <ApplicationCreatedDateRangeFilterFields
        value={selectedCreatedDateDraft}
        onChange={onCreatedDateDraftChange}
      />
      <RangeDatePickerContainer>
        <DatePickerInput
          label="Lease Start Date"
          size="small"
          value={selectedLeaseDateDraft.startDate}
          maxDate={selectedLeaseDateDraft.endDate}
          onChange={(date) => {
            onLeaseDateDraftChange({
              ...selectedLeaseDateDraft,
              startDate: date.target.value,
            });
          }}
        />
        <DatePickerInput
          label="Lease End Date"
          size="small"
          value={selectedLeaseDateDraft.endDate}
          minDate={selectedLeaseDateDraft.startDate}
          onChange={(date) => {
            onLeaseDateDraftChange({
              ...selectedLeaseDateDraft,
              endDate: date.target.value,
            });
          }}
        />
      </RangeDatePickerContainer>
      <Dropdown
        onChange={(e) => onTenantCountDraftChange(e.target.value)}
        options={[
          { value: '', text: 'None' },
          ...new Array(4).fill('').map((_, index) => ({
            value: (index + 1).toString(),
            text: (index + 1).toString(),
          })),
        ]}
        value={selectedTenantCountDraft}
        multiselect
        showSearch={false}
        placeholder=""
        placeholderFlag={false}
        label="Total Resident"
        style={{ width: '100%' }}
      />
    </DropFilterContainer>
  );
}

const DropFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  width: 100%;

  * {
    box-sizing: border-box;
  }
`;

const RangeDatePickerContainer = styled.div`
  display: flex;
  max-width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;

  * {
    box-sizing: border-box;
  }

  & > div {
    width: 50% !important;
  }

  .ui-kit-input-body {
    width: 60%;
  }
`;
